// Thematic canvas previews for non-simulation docs posts.

function fillBackground(ctx, w, h) {
    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, w, h);
}

export function renderTuringPreview(ctx, w, h) {
    fillBackground(ctx, w, h);
    const image = ctx.createImageData(w, h);
    for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++) {
            const u = 0.5 + 0.5 * Math.sin(x * 0.08) * Math.cos(y * 0.08);
            const v = 0.5 + 0.5 * Math.cos(x * 0.06 + 1.2) * Math.sin(y * 0.07);
            const spot = Math.exp(-((u - 0.72) ** 2 + (v - 0.28) ** 2) * 40);
            const stripe = 0.5 + 0.5 * Math.sin(x * 0.12 + y * 0.04);
            const val = Math.max(spot, stripe * 0.55);
            const idx = (y * w + x) * 4;
            image.data[idx] = Math.floor(30 + val * 180);
            image.data[idx + 1] = Math.floor(80 + val * 140);
            image.data[idx + 2] = Math.floor(40 + val * 60);
            image.data[idx + 3] = 255;
        }
    }
    ctx.putImageData(image, 0, 0);
}

export function renderMarkovPreview(ctx, w, h) {
    fillBackground(ctx, w, h);
    const nodes = [
        [0.2, 0.35], [0.5, 0.2], [0.8, 0.35], [0.35, 0.7], [0.65, 0.75],
    ];
    const edges = [[0, 1], [1, 2], [0, 3], [1, 3], [2, 4], [3, 4], [1, 4]];
    ctx.strokeStyle = 'rgba(44, 187, 93, 0.45)';
    ctx.lineWidth = 2;
    edges.forEach(([a, b]) => {
        ctx.beginPath();
        ctx.moveTo(nodes[a][0] * w, nodes[a][1] * h);
        ctx.lineTo(nodes[b][0] * w, nodes[b][1] * h);
        ctx.stroke();
    });
    nodes.forEach(([nx, ny], i) => {
        const x = nx * w;
        const y = ny * h;
        ctx.fillStyle = i % 2 === 0 ? '#2cbb5d' : '#1a8f47';
        ctx.beginPath();
        ctx.arc(x, y, 14, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#fff';
        ctx.font = 'bold 11px sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(String.fromCharCode(65 + i), x, y);
    });
}

export function renderMobilityPreview(ctx, w, h) {
    fillBackground(ctx, w, h);
    const cols = 14;
    const rows = 9;
    const cell = Math.min(w / cols, h / rows);
    const ox = (w - cols * cell) / 2;
    const oy = (h - rows * cell) / 2;
    for (let r = 0; r < rows; r++) {
        for (let c = 0; c < cols; c++) {
            const blocked = (c + r) % 5 === 0 || (c === 6 && r > 2 && r < 6);
            ctx.fillStyle = blocked ? '#333' : '#111';
            ctx.fillRect(ox + c * cell, oy + r * cell, cell - 1, cell - 1);
        }
    }
    const path = [[1, 4], [2, 4], [3, 4], [4, 3], [5, 3], [6, 3], [7, 2], [8, 2], [9, 2], [10, 1]];
    ctx.strokeStyle = '#2cbb5d';
    ctx.lineWidth = 3;
    ctx.beginPath();
    path.forEach(([c, r], i) => {
        const x = ox + c * cell + cell / 2;
        const y = oy + r * cell + cell / 2;
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
    });
    ctx.stroke();
    const [sc, sr] = path[0];
    const [ec, er] = path[path.length - 1];
    ctx.fillStyle = '#4ade80';
    ctx.beginPath();
    ctx.arc(ox + sc * cell + cell / 2, oy + sr * cell + cell / 2, 5, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#f87171';
    ctx.beginPath();
    ctx.arc(ox + ec * cell + cell / 2, oy + er * cell + cell / 2, 5, 0, Math.PI * 2);
    ctx.fill();
}

export function renderLogisticsPreview(ctx, w, h, variant = 'network') {
    fillBackground(ctx, w, h);
    if (variant === 'eoq') {
        ctx.strokeStyle = '#2cbb5d';
        ctx.lineWidth = 2;
        ctx.beginPath();
        for (let x = 20; x < w - 20; x++) {
            const Q = (x - 20) / (w - 40) * 8 + 0.5;
            const tc = 4 / Q + Q * 0.35;
            const y = h - 30 - tc * 18;
            if (x === 20) ctx.moveTo(x, y);
            else ctx.lineTo(x, y);
        }
        ctx.stroke();
        ctx.fillStyle = '#fbbf24';
        ctx.beginPath();
        ctx.arc(w * 0.42, h * 0.45, 5, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#a1a1aa';
        ctx.font = '12px sans-serif';
        ctx.fillText('TC(Q)', 24, 24);
        return;
    }
    if (variant === 'sde') {
        const colors = ['#2cbb5d', '#3b82f6', '#f59e0b'];
        for (let s = 0; s < 3; s++) {
            ctx.strokeStyle = colors[s];
            ctx.lineWidth = 2;
            ctx.beginPath();
            let y = h * 0.35 + s * 12;
            for (let x = 16; x < w - 16; x++) {
                y += Math.sin(x * 0.05 + s) * 1.2 - 0.08 + (s - 1) * 0.02;
                if (x === 16) ctx.moveTo(x, y);
                else ctx.lineTo(x, y);
            }
            ctx.stroke();
        }
        ctx.strokeStyle = 'rgba(239,71,67,0.5)';
        ctx.setLineDash([4, 4]);
        ctx.beginPath();
        ctx.moveTo(16, h * 0.7);
        ctx.lineTo(w - 16, h * 0.7);
        ctx.stroke();
        ctx.setLineDash([]);
        return;
    }
    // network / routes
    const nodes = [
        [0.15, 0.3, '#2cbb5d'],
        [0.15, 0.7, '#2cbb5d'],
        [0.5, 0.35, '#3b82f6'],
        [0.5, 0.65, '#3b82f6'],
        [0.85, 0.25, '#ef4444'],
        [0.85, 0.5, '#ef4444'],
        [0.85, 0.75, '#ef4444'],
    ];
    const edges = [[0, 2], [0, 3], [1, 2], [1, 3], [2, 4], [2, 5], [3, 5], [3, 6]];
    ctx.lineWidth = 2;
    edges.forEach(([a, b], i) => {
        ctx.strokeStyle = i % 2 === 0 ? 'rgba(44,187,93,0.7)' : 'rgba(59,130,246,0.45)';
        ctx.beginPath();
        ctx.moveTo(nodes[a][0] * w, nodes[a][1] * h);
        ctx.lineTo(nodes[b][0] * w, nodes[b][1] * h);
        ctx.stroke();
    });
    nodes.forEach(([nx, ny, color]) => {
        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.arc(nx * w, ny * h, 10, 0, Math.PI * 2);
        ctx.fill();
    });
}

export function renderAudioPreview(ctx, w, h) {
    fillBackground(ctx, w, h);
    const bars = 48;
    const gap = 2;
    const barW = (w - gap * (bars - 1)) / bars;
    for (let i = 0; i < bars; i++) {
        const amp = 0.25 + 0.75 * Math.abs(Math.sin(i * 0.35) * Math.cos(i * 0.12));
        const barH = amp * (h * 0.75);
        const hue = 120 + amp * 40;
        ctx.fillStyle = `hsl(${hue}, 70%, 45%)`;
        ctx.fillRect(i * (barW + gap), h - barH - 8, barW, barH);
    }
    ctx.strokeStyle = 'rgba(44, 187, 93, 0.6)';
    ctx.lineWidth = 2;
    ctx.beginPath();
    for (let x = 0; x < w; x++) {
        const y = h * 0.35 + Math.sin(x * 0.04) * 18 + Math.sin(x * 0.11) * 8;
        if (x === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
    }
    ctx.stroke();
}

const ARCADE_PALETTES = {
    snake: ['#2cbb5d', '#14532d', '#fbbf24'],
    grid: ['#3b82f6', '#1e3a8a', '#ef4444', '#22c55e'],
    board: ['#1e1e1e', '#2cbb5d', '#ef4444', '#fbbf24'],
};

function renderArcadeGrid(ctx, w, h, palette, pattern) {
    fillBackground(ctx, w, h);
    const cols = 12;
    const rows = 8;
    const cell = Math.min(w / cols, h / rows);
    const ox = (w - cols * cell) / 2;
    const oy = (h - rows * cell) / 2;
    for (let r = 0; r < rows; r++) {
        for (let c = 0; c < cols; c++) {
            const idx = pattern(r, c, cols, rows) % palette.length;
            ctx.fillStyle = palette[idx];
            ctx.fillRect(ox + c * cell, oy + r * cell, cell - 1, cell - 1);
        }
    }
}

export function renderArcadePreview(ctx, w, h, variant = 'grid') {
    if (variant === 'snake') {
        renderArcadeGrid(ctx, w, h, ARCADE_PALETTES.snake, (r, c) => {
            if (r === 4 && c > 2 && c < 9) return 0;
            if (r === 4 && c === 9) return 2;
            return 1;
        });
        return;
    }
    if (variant === 'board') {
        renderArcadeGrid(ctx, w, h, ARCADE_PALETTES.board, (r, c) => {
            if ((r + c) % 3 === 0) return 1;
            if (r === 3 && c >= 4 && c <= 6) return 2;
            return 0;
        });
        return;
    }
    renderArcadeGrid(ctx, w, h, ARCADE_PALETTES.grid, (r, c) => (r * 3 + c * 5) % 4);
}
